// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const Strongbox2Icon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Strongbox2/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.492 1.667H6.508c-3.033 0-4.841 1.808-4.841 4.841v6.975c0 3.042 1.808 4.85 4.841 4.85h6.975c3.034 0 4.842-1.808 4.842-4.841V6.508c.008-3.033-1.8-4.841-4.833-4.841Zm2.341 5.2A.836.836 0 0 1 15 7.7h-1.667a.624.624 0 1 0 0 1.25H15c.458 0 .833.375.833.833v.425a.836.836 0 0 1-.833.834h-1.667a.63.63 0 0 0-.625.625.63.63 0 0 0 .625.625H15c.458 0 .833.375.833.833v.208c0 1.384-1.116 2.5-2.5 2.5H6.667a2.497 2.497 0 0 1-2.5-2.5v-.416c0-.459.375-.834.833-.834h1.233c1.225 0 2.2-1.05 2.075-2.3C8.2 8.7 7.208 7.917 6.117 7.917H5a.836.836 0 0 1-.833-.834v-.416c0-1.384 1.116-2.5 2.5-2.5h6.666c1.384 0 2.5 1.116 2.5 2.5v.2ZM4.167 10c0-.458.375-.833.833-.833h.833c.459 0 .834.375.834.833a.836.836 0 0 1-.834.833H5A.836.836 0 0 1 4.167 10Z"
}));
export default Strongbox2Icon;